import React, { createContext, useContext, useState } from 'react';

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const tokenFromURL = urlParams.get("token");
  const token  = tokenFromURL || null
  const [jboId, setJboId] = useState(201); // Set the default token value here
  const [domainStatusTracker,setDomainStatusTracker]=useState();
  
  return (
    <TokenContext.Provider value={{ token,jboId ,setJboId,domainStatusTracker,setDomainStatusTracker}}>
      {children}
    </TokenContext.Provider>
  );
};

export const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error('useToken must be used within a TokenProvider');
  }
  return context;
};

